import Icon from '../../components/Icon.vue'

Icon.register({"regular/file-powerpoint":{"width":384,"height":512,"paths":[{"d":"M369.9 97.9L286 14C277 5 264.8-0.1 252.1-0.1H48C21.5 0 0 21.5 0 48V464C0 490.5 21.5 512 48 512H336C362.5 512 384 490.5 384 464V131.9C384 119.2 378.9 106.9 369.9 97.9zM332.1 128H256V51.9L332.1 128zM48 464V48H208V152C208 165.3 218.7 176 232 176H336V464H48zM120 404V236C120 229.4 125.4 224 132 224H201.2C237.9 224 264 251 264 290.3 264 364.6 195.3 356.8 168.5 356.8V404C168.5 410.6 163.1 416 156.5 416H132C125.4 416 120 410.6 120 404zM168.5 316.6H191.5C199.4 316.6 205.4 314.2 209.6 309.4 218.1 299.6 218 280.9 209.7 271.6 205.6 267 199.8 264.6 192.3 264.6H168.4V316.6z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/regular/file-powerpoint.js
// module id = null
// module chunks = 